export default __webpack_public_path__ + "img/7.0e21653b.jpg";